import React from "react";
import { FeaturesProvider } from "@nextiva/feature-toggle";
import { connect } from "react-redux";

const FeatureFlags = ({ children, user }) => {
  return <FeaturesProvider currentUser={user}>{children}</FeaturesProvider>;
};

const mapStateToProps = (state) => ({
  user: state["__global/user"]?.data ?? null,
});

export default connect(mapStateToProps)(FeatureFlags);
